import React, { useEffect, useState } from "react";
import "./style.css";
import MaintenanceModal from "./MaintenanceModal";

import axios from "axios";
import Swal from "sweetalert2";
import { FiEdit } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { format, utcToZonedTime } from "date-fns-tz";

const Maintenance = () => {
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getData = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/maintenance`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        // Convertir "ahora" a hora de México usando Intl.DateTimeFormat
        const now = new Date();
        const nowMexicoStr = new Intl.DateTimeFormat("en-US", {
          timeZone: "America/Mexico_City",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        }).format(now);

        const [datePart, timePart] = nowMexicoStr.split(", ");
        const [month, day, year] = datePart.split("/");
        const nowMexico = new Date(`${year}-${month}-${day}T${timePart}`);

        const processedData = res.data.data.map((item) => {
          const startDate = new Date(item.date_start);
          const endDate = new Date(item.date_finish);

          const isActive = nowMexico >= startDate && nowMexico <= endDate;

          return {
            ...item,
            status: isActive ? 1 : 2,
          };
        });

        const sortedData = [...processedData].sort((a, b) => {
          return (
            Math.abs(new Date(a.date_start) - nowMexico) -
            Math.abs(new Date(b.date_start) - nowMexico)
          );
        });

        setData(sortedData.slice(0, 10));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShow = () => setShowModal(true);

  const handleEdit = (item) => {
    setEditItem(item);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    const { isConfirmed } = await Swal.fire({
      title: "¿Estás seguro?",
      text: "No podrás revertir esta acción",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (isConfirmed) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/maintenance/delete/${id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        Swal.fire({
          icon: "success",
          title: "¡Eliminado!",
          text: "El registro fue eliminado",
          timer: 2000,
        });
        getData();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo eliminar el registro",
        });
      }
    }
  };

  const formatDateUTC = (dateString) => {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const seconds = String(date.getUTCSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    getData();
  }, []);

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().replace("T", " ").substring(0, 19);
  };

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-md-10">
          <div className="d-flex justify-content-end mb-3">
            <button
              className="btn btn-primary"
              onClick={handleShow}
              disabled={isLoading}
            >
              {isLoading ? "Cargando..." : "Agregar registro"}
            </button>
          </div>

          {isLoading ? (
            <div className="text-center my-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover table-striped table-bordered">
                <thead className="table-dark">
                  <tr>
                    <th className="text-center">Fecha inicio</th>
                    <th className="text-center">Fecha fin</th>
                    <th className="text-center">Estatus</th>
                    <th className="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((d) => (
                      <tr key={d.id} className="text-center align-middle">
                        <td>{formatDateUTC(d.date_start)}</td>
                        <td>{formatDateUTC(d.date_finish)}</td>
                        <td>
                          <svg
                            className={`svg-inline--fa fa-circle fa-w-16 ${
                              d.status === 1 ? "text-success" : "text-danger"
                            }`}
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="circle"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            data-fa-i2svg=""
                          >
                            <path
                              fill="currentColor"
                              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                            ></path>
                          </svg>
                          <i
                            className={`fas fa-circle ${
                              d.status === 1 ? "text-success" : "text-danger"
                            }`}
                          ></i>
                        </td>
                        <td>
                          {d.status === 1 && (
                            <>
                              <button
                                className="btn btn-sm btn-outline-primary mx-1 border-0"
                                onClick={() => handleEdit(d)}
                              >
                                <FiEdit />
                              </button>
                              <button
                                className="btn btn-sm btn-outline-danger mx-1 border-0"
                                onClick={() => handleDelete(d.id)}
                              >
                                <MdDelete />
                              </button>
                            </>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center py-4">
                        {isLoading ? "Cargando..." : "No hay registros"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      <MaintenanceModal
        show={showModal}
        handleClose={() => {
          setShowModal(false);
          setEditItem(null);
        }}
        fetchData={getData}
        editData={editItem}
      />
    </div>
  );
};

export default Maintenance;
